/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { BackendApiClient } from './BackendApiClient';

export type { ActionItemItem } from './models/ActionItemItem';
export type { ActionItemTimestampItem_Input } from './models/ActionItemTimestampItem_Input';
export type { ActionItemTimestampItem_Output } from './models/ActionItemTimestampItem_Output';
export type { Agreement } from './models/Agreement';
export type { AgreementBase } from './models/AgreementBase';
export type { AlertAccessibleMemberChanged } from './models/AlertAccessibleMemberChanged';
export type { AlertInsightGenerated } from './models/AlertInsightGenerated';
export type { AlertLifecycleUpdated } from './models/AlertLifecycleUpdated';
export type { AlertMemberJoined } from './models/AlertMemberJoined';
export type { AlertNewRecord } from './models/AlertNewRecord';
export type { AlertRecordDeleted } from './models/AlertRecordDeleted';
export type { AlertRecordLocked } from './models/AlertRecordLocked';
export type { AlertRecordTeamChanged } from './models/AlertRecordTeamChanged';
export type { AlertRecordUnlocked } from './models/AlertRecordUnlocked';
export type { AlertResponse } from './models/AlertResponse';
export type { AlertRoleChanged } from './models/AlertRoleChanged';
export type { AlertShareRecord } from './models/AlertShareRecord';
export type { AlertTeamInvited } from './models/AlertTeamInvited';
export type { AlertTeamMemberDeleted } from './models/AlertTeamMemberDeleted';
export type { AlertTeamRoleChanged } from './models/AlertTeamRoleChanged';
export type { AlertWorkspaceJoinRequested } from './models/AlertWorkspaceJoinRequested';
export type { ApiKey } from './models/ApiKey';
export type { AppleAuthentication } from './models/AppleAuthentication';
export type { Attendee } from './models/Attendee';
export type { AuditLogAuthLogin } from './models/AuditLogAuthLogin';
export type { AuditLogAuthLogout } from './models/AuditLogAuthLogout';
export { AuditLogDevice } from './models/AuditLogDevice';
export type { AuditLogInstantEvent } from './models/AuditLogInstantEvent';
export { AuditLogIntegration } from './models/AuditLogIntegration';
export { AuditLogLabel } from './models/AuditLogLabel';
export { AuditLogMember } from './models/AuditLogMember';
export { AuditLogRecord } from './models/AuditLogRecord';
export { AuditLogRecordExport } from './models/AuditLogRecordExport';
export type { AuditLogRecordInsight } from './models/AuditLogRecordInsight';
export { AuditLogRecordLabel } from './models/AuditLogRecordLabel';
export type { AuditLogRecordRetranscribe } from './models/AuditLogRecordRetranscribe';
export type { AuditLogResponse } from './models/AuditLogResponse';
export { AuditLogSharedRecord } from './models/AuditLogSharedRecord';
export { AuditLogTeam } from './models/AuditLogTeam';
export type { AuditLogTeamMemberAdd } from './models/AuditLogTeamMemberAdd';
export { AuditLogTeamMemberOther } from './models/AuditLogTeamMemberOther';
export type { AuditLogWithDetail } from './models/AuditLogWithDetail';
export type { AuditLogWorkspace } from './models/AuditLogWorkspace';
export { AuditLogWorkspaceInvite } from './models/AuditLogWorkspaceInvite';
export { AuditRecordDetail } from './models/AuditRecordDetail';
export { AuthInfoProvider } from './models/AuthInfoProvider';
export type { AuthMagicLinkCreateRequest } from './models/AuthMagicLinkCreateRequest';
export { BaseTeamRole } from './models/BaseTeamRole';
export { BaseWorkspaceRole } from './models/BaseWorkspaceRole';
export type { BlockRule } from './models/BlockRule';
export type { BlockRuleUpdateRequest } from './models/BlockRuleUpdateRequest';
export type { Body_claim_password_v1_user_claim_password_post } from './models/Body_claim_password_v1_user_claim_password_post';
export type { Body_create_custom_team_role_v1_workspaces__slug__team_roles_custom_post } from './models/Body_create_custom_team_role_v1_workspaces__slug__team_roles_custom_post';
export type { Body_create_custom_workspace_role_v1_workspaces__slug__workspace_roles_custom_post } from './models/Body_create_custom_workspace_role_v1_workspaces__slug__workspace_roles_custom_post';
export type { Body_create_person_v1_workspace__slug__integrations_pipedrive_persons_post } from './models/Body_create_person_v1_workspace__slug__integrations_pipedrive_persons_post';
export type { Body_create_subscription_v1_notification_subscription_post } from './models/Body_create_subscription_v1_notification_subscription_post';
export type { Body_delete_subscription_v1_notification_subscription_delete } from './models/Body_delete_subscription_v1_notification_subscription_delete';
export type { Body_forgot_password_v1_user_forgot_password_post } from './models/Body_forgot_password_v1_user_forgot_password_post';
export type { Body_logout_v1_user_logout_post } from './models/Body_logout_v1_user_logout_post';
export type { Body_register_v1_workspace__slug__card_put } from './models/Body_register_v1_workspace__slug__card_put';
export type { Body_request_join_to_workspace_v1_user_workspace_join_requests_post } from './models/Body_request_join_to_workspace_v1_user_workspace_join_requests_post';
export type { Body_server_side_upload_v1_workspace__slug__record__id__upload_fallback_post } from './models/Body_server_side_upload_v1_workspace__slug__record__id__upload_fallback_post';
export type { Body_set_password_v1_user_set_password_post } from './models/Body_set_password_v1_user_set_password_post';
export type { Body_set_password_verify_v1_user_set_password_verify_post } from './models/Body_set_password_verify_v1_user_set_password_verify_post';
export type { Body_signup_v1_user_post } from './models/Body_signup_v1_user_post';
export { Body_signup_verify_v1_user_signup_verify_post } from './models/Body_signup_verify_v1_user_signup_verify_post';
export type { Body_update_custom_team_role_v1_workspaces__slug__team_roles__role_id__patch } from './models/Body_update_custom_team_role_v1_workspaces__slug__team_roles__role_id__patch';
export type { Body_update_custom_workspace_role_v1_workspaces__slug__workspace_roles__role_id__patch } from './models/Body_update_custom_workspace_role_v1_workspaces__slug__workspace_roles__role_id__patch';
export type { Body_update_join_request_v1_workspace__slug__join_requests_patch } from './models/Body_update_join_request_v1_workspace__slug__join_requests_patch';
export { Body_update_locale_v1_user_locale_patch } from './models/Body_update_locale_v1_user_locale_patch';
export type { Body_update_phone_number_v1_workspace__slug__record__id__phone_number_put } from './models/Body_update_phone_number_v1_workspace__slug__record__id__phone_number_put';
export type { Body_update_recording_schedule_v1_workspace__slug__event__id__recording_schedule_patch } from './models/Body_update_recording_schedule_v1_workspace__slug__event__id__recording_schedule_patch';
export { Body_update_transcribe_config_v1_workspace__slug__event__id__transcribe_config_patch } from './models/Body_update_transcribe_config_v1_workspace__slug__event__id__transcribe_config_patch';
export type { Body_update_transcribe_config_v1_workspace__slug__record__id__transcribe_config_put } from './models/Body_update_transcribe_config_v1_workspace__slug__record__id__transcribe_config_put';
export type { Body_upload_idp_metadata_v1_workspaces__slug__saml_idp_metadata_post } from './models/Body_upload_idp_metadata_v1_workspaces__slug__saml_idp_metadata_post';
export type { Body_zapier_subscribe_v1_zapier_post } from './models/Body_zapier_subscribe_v1_zapier_post';
export type { Body_zapier_unsubscribe_v1_zapier_delete } from './models/Body_zapier_unsubscribe_v1_zapier_delete';
export type { callabo__models__audit__Device } from './models/callabo__models__audit__Device';
export { callabo__models__license__LicensePlan } from './models/callabo__models__license__LicensePlan';
export { callabo__schemas__device__Device } from './models/callabo__schemas__device__Device';
export type { callabo__schemas__license__LicensePlan } from './models/callabo__schemas__license__LicensePlan';
export type { ConfluenceExportParams } from './models/ConfluenceExportParams';
export type { ConfluenceSearchedObject } from './models/ConfluenceSearchedObject';
export type { ConfluenceSpace } from './models/ConfluenceSpace';
export type { ConversationShare } from './models/ConversationShare';
export type { CreateBlockRuleBulkRequest } from './models/CreateBlockRuleBulkRequest';
export type { CreateBlockRuleRequest } from './models/CreateBlockRuleRequest';
export { CreatedTrustedDevice } from './models/CreatedTrustedDevice';
export type { DailyUsage } from './models/DailyUsage';
export type { DateTimeItem_Input } from './models/DateTimeItem_Input';
export type { DateTimeItem_Output } from './models/DateTimeItem_Output';
export { DeviceSession } from './models/DeviceSession';
export type { Dialog } from './models/Dialog';
export type { DialogUpdate } from './models/DialogUpdate';
export type { EmailAuthentication } from './models/EmailAuthentication';
export type { EmailUserCreateRequest } from './models/EmailUserCreateRequest';
export type { Event } from './models/Event';
export type { EventTranscribeLanguageKeywords } from './models/EventTranscribeLanguageKeywords';
export { EventWithExtra } from './models/EventWithExtra';
export type { ExtraRecordingQuota } from './models/ExtraRecordingQuota';
export type { Geo } from './models/Geo';
export type { GoogleAuthentication } from './models/GoogleAuthentication';
export type { HTMLStr } from './models/HTMLStr';
export type { HTTPValidationError } from './models/HTTPValidationError';
export type { IdPMetadataUrlRequest } from './models/IdPMetadataUrlRequest';
export type { InsightsExportOutput } from './models/InsightsExportOutput';
export { InsightTranslationRequest } from './models/InsightTranslationRequest';
export type { InsightValue_Input } from './models/InsightValue_Input';
export type { InsightValue_Output } from './models/InsightValue_Output';
export type { InstantEvent } from './models/InstantEvent';
export type { InstantEventCreateRequest } from './models/InstantEventCreateRequest';
export type { Integration } from './models/Integration';
export type { IntegrationCreateRequest } from './models/IntegrationCreateRequest';
export { IntegrationType } from './models/IntegrationType';
export type { Label } from './models/Label';
export type { LabelCreateRequest } from './models/LabelCreateRequest';
export type { LabelUpdateRequest } from './models/LabelUpdateRequest';
export type { LabelWithRecordCount } from './models/LabelWithRecordCount';
export type { LicensePaymentHistory } from './models/LicensePaymentHistory';
export { LicensePaymentType } from './models/LicensePaymentType';
export type { LicensePlanPricing } from './models/LicensePlanPricing';
export type { LicenseSubscription } from './models/LicenseSubscription';
export { LicenseSubscriptionStatus } from './models/LicenseSubscriptionStatus';
export { LicenseSubscriptionUpdateRequest } from './models/LicenseSubscriptionUpdateRequest';
export type { LinearIssueCreateParams } from './models/LinearIssueCreateParams';
export type { LinearLabel } from './models/LinearLabel';
export type { LinearMember } from './models/LinearMember';
export type { LinearTeam } from './models/LinearTeam';
export type { LoginResponse } from './models/LoginResponse';
export type { MagiActiveJobResponse } from './models/MagiActiveJobResponse';
export type { MagicLinkCreateResponse } from './models/MagicLinkCreateResponse';
export type { MagicLinkLoginRequest } from './models/MagicLinkLoginRequest';
export type { MagicLinkLoginResponse } from './models/MagicLinkLoginResponse';
export type { MagiCompletedJobResponse_list_list_Utterance___ } from './models/MagiCompletedJobResponse_list_list_Utterance___';
export type { MagiDelayedJobResponse } from './models/MagiDelayedJobResponse';
export type { MagiExtractCallbackResult } from './models/MagiExtractCallbackResult';
export { MagiExtractType } from './models/MagiExtractType';
export type { MagiFailedJobResponse } from './models/MagiFailedJobResponse';
export type { MagiGrantTokenResponse } from './models/MagiGrantTokenResponse';
export type { MagiJobNotCompletedResponses } from './models/MagiJobNotCompletedResponses';
export { MagiJobResponseBase } from './models/MagiJobResponseBase';
export type { MagiRecordInsightCallbackDataResultPlus } from './models/MagiRecordInsightCallbackDataResultPlus';
export type { MagiRecordInsightCallbackDataResultPlusInsight } from './models/MagiRecordInsightCallbackDataResultPlusInsight';
export type { MagiRecordInsightCallbackDataResultPlusInsightDateTime } from './models/MagiRecordInsightCallbackDataResultPlusInsightDateTime';
export type { MagiRecordInsightCallbackDataResultPlusTimeline } from './models/MagiRecordInsightCallbackDataResultPlusTimeline';
export type { MagiRecordInsightCallbackDataResultPro } from './models/MagiRecordInsightCallbackDataResultPro';
export { MagiRecordInsightData } from './models/MagiRecordInsightData';
export { MagiRefineCallbackRequest } from './models/MagiRefineCallbackRequest';
export type { MagiTranscribeRetryCallbackRequest } from './models/MagiTranscribeRetryCallbackRequest';
export type { MagiTranscribeRetryJobResponse } from './models/MagiTranscribeRetryJobResponse';
export type { MagiTranscribeRetrySegment } from './models/MagiTranscribeRetrySegment';
export type { MagiWaitingJobResponse } from './models/MagiWaitingJobResponse';
export type { MaskedUserForJoinRequest } from './models/MaskedUserForJoinRequest';
export type { Member } from './models/Member';
export type { MemberDetail } from './models/MemberDetail';
export type { MemberDetailWithTeams } from './models/MemberDetailWithTeams';
export type { MemberForMemberList } from './models/MemberForMemberList';
export type { MemberQuota } from './models/MemberQuota';
export type { MemberUpdateRequest } from './models/MemberUpdateRequest';
export type { MemberWithUser } from './models/MemberWithUser';
export type { MemberWorkspaceRole } from './models/MemberWorkspaceRole';
export { MFAType } from './models/MFAType';
export type { MicrosoftAuthentication } from './models/MicrosoftAuthentication';
export type { MicrosoftOldAuthentication } from './models/MicrosoftOldAuthentication';
export type { Monologist } from './models/Monologist';
export type { Monologue } from './models/Monologue';
export type { MonthlyUsage } from './models/MonthlyUsage';
export type { MSGraphChannel } from './models/MSGraphChannel';
export type { MSGraphChannelExportParam } from './models/MSGraphChannelExportParam';
export type { MSGraphChat } from './models/MSGraphChat';
export type { MSGraphChatExportParam } from './models/MSGraphChatExportParam';
export type { MSGraphMember } from './models/MSGraphMember';
export type { MSGraphTeam } from './models/MSGraphTeam';
export type { MyIp } from './models/MyIp';
export type { NewAlertResponse } from './models/NewAlertResponse';
export { NotificationCategory } from './models/NotificationCategory';
export { NotificationChannel } from './models/NotificationChannel';
export type { NotificationSubscription } from './models/NotificationSubscription';
export { NotionExportParams } from './models/NotionExportParams';
export type { NotionObject } from './models/NotionObject';
export type { OAuth2CodeGrantRequest } from './models/OAuth2CodeGrantRequest';
export type { PaginationMeta } from './models/PaginationMeta';
export type { Paging_EventWithExtra_ } from './models/Paging_EventWithExtra_';
export type { Paging_ExtraRecordingQuota_ } from './models/Paging_ExtraRecordingQuota_';
export type { Paging_LicensePaymentHistory_ } from './models/Paging_LicensePaymentHistory_';
export type { Paging_LicenseSubscription_ } from './models/Paging_LicenseSubscription_';
export type { Paging_RecordDetail_ } from './models/Paging_RecordDetail_';
export type { Paging_RecordWithRecordPermission_ } from './models/Paging_RecordWithRecordPermission_';
export type { PaymentResponse } from './models/PaymentResponse';
export { PaymentStatus } from './models/PaymentStatus';
export type { Permission } from './models/Permission';
export { PermissionResource } from './models/PermissionResource';
export { PermissionStatus } from './models/PermissionStatus';
export type { PipedriveDeal } from './models/PipedriveDeal';
export type { PipedriveExportParam } from './models/PipedriveExportParam';
export type { PipedriveLead } from './models/PipedriveLead';
export type { PipedriveOrganization } from './models/PipedriveOrganization';
export type { PipedrivePerson } from './models/PipedrivePerson';
export { PostTrustedDeviceRequest } from './models/PostTrustedDeviceRequest';
export { ProvisionType } from './models/ProvisionType';
export { PushDeviceRequest } from './models/PushDeviceRequest';
export type { RecordAccessUpdate } from './models/RecordAccessUpdate';
export { RecordCreateRequest } from './models/RecordCreateRequest';
export type { RecordCustomInsight } from './models/RecordCustomInsight';
export type { RecordCustomInsightCreateRequest } from './models/RecordCustomInsightCreateRequest';
export { RecordCustomInsightTranslateRequest } from './models/RecordCustomInsightTranslateRequest';
export { RecordDetail } from './models/RecordDetail';
export type { RecordExportHistory } from './models/RecordExportHistory';
export { RecordExportPlatformType } from './models/RecordExportPlatformType';
export { RecordExportType } from './models/RecordExportType';
export type { RecordExtra } from './models/RecordExtra';
export type { RecordForDashboardItem } from './models/RecordForDashboardItem';
export type { RecordForDashboardResponse } from './models/RecordForDashboardResponse';
export { RecordForRelated } from './models/RecordForRelated';
export type { RecordHedwigExportRequest } from './models/RecordHedwigExportRequest';
export type { RecordingQuota } from './models/RecordingQuota';
export { RecordInsight } from './models/RecordInsight';
export type { RecordInsightLanguage } from './models/RecordInsightLanguage';
export type { RecordInsightUpdateRequest } from './models/RecordInsightUpdateRequest';
export { RecordScope } from './models/RecordScope';
export type { RecordSlackExportRequest } from './models/RecordSlackExportRequest';
export { RecordSource } from './models/RecordSource';
export { RecordTranscribeRequest } from './models/RecordTranscribeRequest';
export type { RecordUpdate } from './models/RecordUpdate';
export type { RecordUploadComplete } from './models/RecordUploadComplete';
export { RecordWithRecordPermission } from './models/RecordWithRecordPermission';
export type { RefreshAuthentication } from './models/RefreshAuthentication';
export type { RelatedRecord } from './models/RelatedRecord';
export { RelatedRecordItem } from './models/RelatedRecordItem';
export type { RelationBlock } from './models/RelationBlock';
export type { Requires2FAResponse } from './models/Requires2FAResponse';
export type { RolePermissionInput } from './models/RolePermissionInput';
export type { SalesforceAccount } from './models/SalesforceAccount';
export type { SalesforceCase } from './models/SalesforceCase';
export type { SalesforceContact } from './models/SalesforceContact';
export type { SalesforceContactCreateParams } from './models/SalesforceContactCreateParams';
export type { SalesforceExportCreateCaseParams } from './models/SalesforceExportCreateCaseParams';
export type { SalesforceExportCreateContactParams } from './models/SalesforceExportCreateContactParams';
export type { SalesforceExportCreateLeadParams } from './models/SalesforceExportCreateLeadParams';
export type { SalesforceExportParams } from './models/SalesforceExportParams';
export type { SalesforceExportParamsV2 } from './models/SalesforceExportParamsV2';
export type { SalesforceLead } from './models/SalesforceLead';
export type { SalesforceOpportunity } from './models/SalesforceOpportunity';
export type { SalesforceWorkOrder } from './models/SalesforceWorkOrder';
export type { SCIMGroupCreateRequest } from './models/SCIMGroupCreateRequest';
export type { SCIMGroupMember } from './models/SCIMGroupMember';
export type { SCIMGroupResponse } from './models/SCIMGroupResponse';
export type { SCIMGroupUpdateRequest } from './models/SCIMGroupUpdateRequest';
export type { SCIMListResponse } from './models/SCIMListResponse';
export type { SCIMToken } from './models/SCIMToken';
export type { SCIMTokenCreateRequest } from './models/SCIMTokenCreateRequest';
export type { SCIMUserCreateRequest } from './models/SCIMUserCreateRequest';
export type { SCIMUserName } from './models/SCIMUserName';
export type { SCIMUserResponse } from './models/SCIMUserResponse';
export type { SCIMUserUpdateRequest } from './models/SCIMUserUpdateRequest';
export { Scope } from './models/Scope';
export type { ScopedTokenAuthentication } from './models/ScopedTokenAuthentication';
export type { SearchResultIds } from './models/SearchResultIds';
export type { ServiceSetting } from './models/ServiceSetting';
export type { SharedRecord } from './models/SharedRecord';
export type { SharedRecordAuthentication } from './models/SharedRecordAuthentication';
export type { SharedRecordAuthResponse } from './models/SharedRecordAuthResponse';
export { SharedRecordDuration } from './models/SharedRecordDuration';
export type { SharedRecordPutRequest } from './models/SharedRecordPutRequest';
export type { SlackChannel } from './models/SlackChannel';
export type { SlackChannelIntegration } from './models/SlackChannelIntegration';
export type { SlackIntegration } from './models/SlackIntegration';
export type { SlackIntegrationCreate } from './models/SlackIntegrationCreate';
export type { SpeakerInfoValue } from './models/SpeakerInfoValue';
export type { SpeakerInfoValueSchema } from './models/SpeakerInfoValueSchema';
export type { SuggestedWorkspace } from './models/SuggestedWorkspace';
export type { TContentItem_Input } from './models/TContentItem_Input';
export type { TContentItem_Output } from './models/TContentItem_Output';
export type { Team } from './models/Team';
export type { TeamCreateRequest } from './models/TeamCreateRequest';
export type { TeamCustomRoleCreate } from './models/TeamCustomRoleCreate';
export type { TeamCustomRoleUpdate } from './models/TeamCustomRoleUpdate';
export type { TeamDetail } from './models/TeamDetail';
export type { TeamMemberBulkCreate } from './models/TeamMemberBulkCreate';
export type { TeamMemberCreate } from './models/TeamMemberCreate';
export type { TeamMemberDetail } from './models/TeamMemberDetail';
export type { TeamMemberForMemberDetail } from './models/TeamMemberForMemberDetail';
export type { TeamMemberUpdateRequest } from './models/TeamMemberUpdateRequest';
export type { TeamMemberWithTeamRoles } from './models/TeamMemberWithTeamRoles';
export type { TeamRole } from './models/TeamRole';
export type { TeamRolePermission } from './models/TeamRolePermission';
export type { TeamSlackChannelIntegration } from './models/TeamSlackChannelIntegration';
export type { TeamSlackChannelIntegrationSetting } from './models/TeamSlackChannelIntegrationSetting';
export type { TeamUpdateRequest } from './models/TeamUpdateRequest';
export { Term } from './models/Term';
export { TermLong } from './models/TermLong';
export type { Token } from './models/Token';
export { TranscribeLanguage } from './models/TranscribeLanguage';
export { TranscribeLanguageForTeam } from './models/TranscribeLanguageForTeam';
export { TranscribeResultBaseLanguage } from './models/TranscribeResultBaseLanguage';
export { TrustedDevice } from './models/TrustedDevice';
export type { TrustedDeviceVerificationStartResponse } from './models/TrustedDeviceVerificationStartResponse';
export type { UpdateDeviceRequest } from './models/UpdateDeviceRequest';
export type { User } from './models/User';
export type { UserExists } from './models/UserExists';
export type { UserExistsRequest } from './models/UserExistsRequest';
export { UserLocale } from './models/UserLocale';
export { UserStatus } from './models/UserStatus';
export type { UserUpdateRequest } from './models/UserUpdateRequest';
export type { Utterance } from './models/Utterance';
export type { ValidationError } from './models/ValidationError';
export type { WebhookRecordSampleRequest } from './models/WebhookRecordSampleRequest';
export { Workspace } from './models/Workspace';
export { WorkspaceAlert } from './models/WorkspaceAlert';
export type { WorkspaceCard } from './models/WorkspaceCard';
export type { WorkspaceCreate } from './models/WorkspaceCreate';
export type { WorkspaceCustomRoleCreate } from './models/WorkspaceCustomRoleCreate';
export type { WorkspaceCustomRoleUpdate } from './models/WorkspaceCustomRoleUpdate';
export type { WorkspaceDomain } from './models/WorkspaceDomain';
export type { WorkspaceInvite } from './models/WorkspaceInvite';
export type { WorkspaceInviteBulkRequest } from './models/WorkspaceInviteBulkRequest';
export type { WorkspaceInviteRequest } from './models/WorkspaceInviteRequest';
export type { WorkspaceInviteRole } from './models/WorkspaceInviteRole';
export { WorkspaceInviteStatus } from './models/WorkspaceInviteStatus';
export type { WorkspaceJoinRequest } from './models/WorkspaceJoinRequest';
export { WorkspaceJoinRequestStatus } from './models/WorkspaceJoinRequestStatus';
export type { WorkspaceOption } from './models/WorkspaceOption';
export type { WorkspaceRestrictedEventWord } from './models/WorkspaceRestrictedEventWord';
export type { WorkspaceRestrictedEventWordCreateRequest } from './models/WorkspaceRestrictedEventWordCreateRequest';
export type { WorkspaceRolePermission } from './models/WorkspaceRolePermission';
export type { WorkspaceRoleWithPermissions } from './models/WorkspaceRoleWithPermissions';
export type { WorkspaceRoleWithRolePermissions } from './models/WorkspaceRoleWithRolePermissions';
export type { WorkspaceSAMLConfig } from './models/WorkspaceSAMLConfig';
export type { WorkspaceSAMLConfigForPublic } from './models/WorkspaceSAMLConfigForPublic';
export type { WorkspaceSAMLConfigUpdate } from './models/WorkspaceSAMLConfigUpdate';
export { WorkspaceStatus } from './models/WorkspaceStatus';
export type { WorkspaceUpdate } from './models/WorkspaceUpdate';
export type { ZapierMe } from './models/ZapierMe';
export { ZapierTriggerRecord } from './models/ZapierTriggerRecord';
export type { ZapierTriggerRecordEvent } from './models/ZapierTriggerRecordEvent';
export type { ZapierTriggerRecordUser } from './models/ZapierTriggerRecordUser';

export { AlertService } from './services/AlertService';
export { ApiKeyService } from './services/ApiKeyService';
export { AuditLogService } from './services/AuditLogService';
export { BlockRulesService } from './services/BlockRulesService';
export { ClaudeTemporaryService } from './services/ClaudeTemporaryService';
export { ConfluenceService } from './services/ConfluenceService';
export { DashboardService } from './services/DashboardService';
export { EventService } from './services/EventService';
export { ForMagiAuthService } from './services/ForMagiAuthService';
export { ForMagiCallbackService } from './services/ForMagiCallbackService';
export { ForMagiTranscribeRetryService } from './services/ForMagiTranscribeRetryService';
export { GoogleCalendarService } from './services/GoogleCalendarService';
export { IntegrationService } from './services/IntegrationService';
export { LabelService } from './services/LabelService';
export { LicenseService } from './services/LicenseService';
export { LinearService } from './services/LinearService';
export { MagicLinkService } from './services/MagicLinkService';
export { MembersService } from './services/MembersService';
export { MsTeamsService } from './services/MsTeamsService';
export { NotificationService } from './services/NotificationService';
export { NotionService } from './services/NotionService';
export { OutlookCalendarService } from './services/OutlookCalendarService';
export { PipedriveService } from './services/PipedriveService';
export { QuotaService } from './services/QuotaService';
export { RecordService } from './services/RecordService';
export { SalesforceService } from './services/SalesforceService';
export { SamlService } from './services/SamlService';
export { ScimService } from './services/ScimService';
export { ServiceService } from './services/ServiceService';
export { ShareRecordDetailService } from './services/ShareRecordDetailService';
export { SlackBotService } from './services/SlackBotService';
export { SlackChannelService } from './services/SlackChannelService';
export { SlackUnfurlService } from './services/SlackUnfurlService';
export { TeamService } from './services/TeamService';
export { TeamIntegrationService } from './services/TeamIntegrationService';
export { TeamRecordService } from './services/TeamRecordService';
export { UsageService } from './services/UsageService';
export { UserService } from './services/UserService';
export { WebhookService } from './services/WebhookService';
export { WorkspaceService } from './services/WorkspaceService';
export { WorkspaceCardService } from './services/WorkspaceCardService';
export { WorkspaceInviteService } from './services/WorkspaceInviteService';
export { WorkspaceRestrictedEventWordService } from './services/WorkspaceRestrictedEventWordService';
export { WorkspaceRolesService } from './services/WorkspaceRolesService';
export { ZapierService } from './services/ZapierService';
